// search-store-provider.tsx
"use client";

import { type ReactNode, createContext, useContext, useRef } from "react";
import { useStore } from "zustand";

import {
  type SearchStore,
  createSearchStore,
  initSearchStore,
} from "@/stores/search-store";
export type SearchStoreApi = ReturnType<typeof createSearchStore>;

const SearchStoreContext = createContext<SearchStoreApi | undefined>(undefined);

type SearchStoreProviderProps = {
  children: ReactNode;
};

export function SearchStoreProvider({ children }: SearchStoreProviderProps) {
  const storeRef = useRef<SearchStoreApi | null>(null);
  if (!storeRef.current) {
    storeRef.current = createSearchStore(initSearchStore());
  }

  return (
    <SearchStoreContext.Provider value={storeRef.current}>
      {children}
    </SearchStoreContext.Provider>
  );
}

export const useSearchStore = <T,>(selector: (state: SearchStore) => T): T => {
  const store = useContext(SearchStoreContext);

  if (!store) {
    throw new Error("useSearchStore must be used within a SearchStoreProvider");
  }

  return useStore(store, selector);
};
